export default (clientHttp, apiVersion) => ({
  read(params) {
    return clientHttp.get(`${apiVersion}/contract`, { ...params })
  },
})
